require('../styles/modules/board.scss');

import React, { Component, PropTypes } from 'react'
import Swipeable from 'react-swipeable'
import Goal from './Goal'
import Robot from './Robot'
import Redo from './Redo'
import BoardCanvas from './BoardCanvas'
import LogContainer from '../containers/LogContainer'

class Board extends Component {
  constructor(props) {
    super(props);
    this.state = { size: window.innerWidth > 700 ? 40 : 20 }
  }
  componentDidMount(){
    const { board, newGame, goals, isChallenge, fetchChallenge, fetchNextChallengeTime } = this.props
    var self = this;
    document.onkeydown = function(e) {
        const { status, moveRobot, nextRobot } = self.props
        switch (e.keyCode) {
          case 37: // left
           if(status.currentColor){
            e.preventDefault()
            moveRobot(status.currentColor, 'left')
           }
           break;
           case 38: // up
           if(status.currentColor){
            e.preventDefault()
            moveRobot(status.currentColor, 'up')
           }
           break;
           case 39: // right
           if(status.currentColor){
            e.preventDefault()
            moveRobot(status.currentColor, 'right')
           }
           break;
           case 40: // down
           if(status.currentColor){
            e.preventDefault()
            moveRobot(status.currentColor, 'down')
           }
           break;
           case 9: //tab
           e.preventDefault()
           nextRobot(status.currentColor)
           default:
           return;
        }
    };
    //TODO: debounce this
    window.onresize = this.onScreenResize.bind(this)
    if(isChallenge){
      fetchChallenge()
      fetchNextChallengeTime()
    } else {
      newGame();
    }
  }
  //need to rerender board on screen resize
  onScreenResize() {
    if(window.innerWidth > 700 && this.state.size === 20){
      this.setState({
        size: 40
      })
    }
    if(window.innerWidth <= 700 && this.state.size === 40){
      this.setState({
        size: 20
      })
    }
  }
  getRobotProps(color) {
    const { selectRobot, status, moveRobot } = this.props
    return {
      selectRobot: selectRobot,
      currentColor: status.currentColor,
      moveRobot: moveRobot,
      key: color,
      size: this.state.size
    }
  }

  getLogProps(){
    return {
      data: this.props.log,
      loadState: this.props.loadState,
      submitChallenge: this.props.submitChallenge,
      isMobile: this.state.size === 20,
      pendingSolution: this.props.status.solution,
      nextChallenge: this.props.nextChallenge
    }
  }

  handleDeselect(e){
    const { status, deselectRobot, loadState, log } = this.props
    if(status.currentColor && !e.target.classList.contains('robot')){
      deselectRobot()
    }
    if(e.target.classList.contains('redo-button') || e.target.classList.contains('redo')){
      log.records.length && loadState(log.records[log.currentRecordIndex])
    }
  }

  handleSwiping(e){
    if(this.props.status && this.props.status.currentColor){
      e.preventDefault()
    }
  }

  handleSwipe(direction, e) {
    const { moveRobot, status } = this.props
    if(status.currentColor) moveRobot(status.currentColor, direction)
  }

  renderRobots() {
    const { robot, status } = this.props
    let robots = [];
    for(var color in robot){
      robots.push(<Robot {...robot[color]} { ...this.getRobotProps(color) }/> )
    }
    return robots
  }

  renderMobileControl() {
    if(this.state.size > 20) return;
    const { selectRobot } = this.props
    return <div className = 'controls'>
             <div onClick = { selectRobot.bind(this, 'red') } className = 'control-red'></div>
             <div onClick = { selectRobot.bind(this, 'yellow') } className = 'control-yellow'></div>
             <div onClick = { selectRobot.bind(this, 'blue') } className = 'control-blue'></div>
             <div onClick = { selectRobot.bind(this, 'green') } className = 'control-green'></div>
           </div>
  }

  renderRedo(){
    return <Redo />
  }

  render() {
    const { size } = this.state
    const { board, newGame, goals, status, deselectRobot} = this.props
    return (
      <div className = 'play-mode'>
        { this.renderMobileControl() }
        <Swipeable
          onSwiping={this.handleSwiping.bind(this)}
          onSwipedUp={this.handleSwipe.bind(this, 'up') }
          onSwipedRight={this.handleSwipe.bind(this, 'right') }
          onSwipedDown={this.handleSwipe.bind(this, 'down') }
          onSwipedLeft={this.handleSwipe.bind(this, 'left') }>
          <div className = 'board' onClick = { this.handleDeselect.bind(this) }>
            <BoardCanvas boardProps = { board } isMobile = { this.state.size === 20 } />
            { this.renderRobots() }
            <Goal size = { size } { ...goals }/>
            { this.renderRedo() }
          </div>
        </Swipeable>
        <LogContainer { ...this.getLogProps() }/>
      </div>
    )
  }
}

Board.propTypes = {
}

export default Board



// WEBPACK FOOTER //
// ./components/Board.js